import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import { BrowserControlService } from '../../../../cross-team-shared/misc-services/browser-control.service';

export interface LinkedRadioButtonDropdownItem {
  label: string;
  active: boolean;
  url?: string;
  extraContent?: TemplateRef<unknown>;
}

@Component({
  selector: 'h3-linked-radio-button-dropdown',
  templateUrl: './linked-radio-button-dropdown.component.html',
  styleUrls: ['./linked-radio-button-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LinkedRadioButtonDropdownComponent {
  @Input({ required: true }) dropdownTitle!: string;
  @Input() dropdownItems?: LinkedRadioButtonDropdownItem[];
  @Input() matMenuClass?: string;

  constructor(private browserControlService: BrowserControlService) {}

  navigate(url: string) {
    void this.browserControlService.navigateTo(url);
  }
}
